import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=accddf98&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('accddf98')) {
      api.createRecord('accddf98', component.options)
    } else {
      api.reload('accddf98', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=accddf98&", function () {
      api.rerender('accddf98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Accordion.vue"
export default component.exports